// Dependencies
import React, { Fragment } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Security
import { HasPermission } from 'Core/security';

// Components
import AlertsMainView from 'Modules/alerts/views/main';

const Alerts = ({ match }) => {
  const user = useSelector(state => state.securityRedux.user);

  return (
    <Routes>
      {
        HasPermission(user, ["alrt"], [222, 6, 7]) &&
        <Fragment>
          <Route path='/' element={<Navigate to="/app/alerts/main"/>}></Route>
          <Route path='main' element={<AlertsMainView />} />
        </Fragment>
      }
      <Route path="*" element={<Navigate to="/app/error" />} />
    </Routes>
  )
}

export default Alerts;